import { z } from 'zod'

const dateFromStringSchema = z.union([
  z.date(),
  z.iso.datetime().transform(value => new Date(value))
])

export const ApiErrorSchema = z.object({
  status: z.number().min(100).max(599),
  message: z.string().min(0),
  correlationId: z.uuid(),
  messageCode: z.string().optional(),
  timestamp: dateFromStringSchema,
  validationError: z.map(z.string(), z.array(z.string())).optional()
})

export type ApiErrorData = z.infer<typeof ApiErrorSchema>
